import { observer } from 'mobx-react-lite';

import { useMapPagePresenter } from '../MapPagePresenter';
import { MapPageErrorBoundary } from './Components/MapPageErrorBoundary';
import { MapPageLoading } from './Components/MapPageLoading';
import { MapLayout } from './MapLayout/MapLayout';

export const MapPageContent = observer(function MapPageContent() {
  const presenter = useMapPagePresenter();
  const { isFetching } = presenter;

  return (
    <MapPageErrorBoundary>
      {isFetching && <MapPageLoading />}
      <MapLayout />
    </MapPageErrorBoundary>
  );
});
